import React, { Component } from "react";
import { Link } from "gatsby";

class ServiceSection extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <div id="our-services" className="row services-row">
          <div className="col-12 text-center mt-5 mb-5">
            <p className="head-top-desc">Our Client Commitments</p>
            <h2 className="my-h2-head mb-md-4">
              Explore new business solutions
            </h2>
          </div>

          <div className="col-md-6 p-0 my-mt-sm-3">
            <div className="card h-100 p-4 service">
              <div className="row no-gutters">
                <div className="col-md-2">
                  <img
                    className="service-icon img-fluid"
                    src={require("../../../static/images/website-creation-icon.png")}
                  />
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0 pl-3">
                    <h3 className="my-h3-head">Custom Website Creation</h3>
                    <p className="service-desc">
                      Creating Custom URL's, eye catching webpages, and
                      organized for the customers needs. We do all of this for
                      our clients to give them maximum exposure for the
                      competitive online world.
                    </p>
                    <Link className="service-link" to="">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 p-0 my-mt-sm-3">
            <div className="card h-100 p-4 service">
              <div className="row no-gutters">
                <div className="col-md-2">
                  <img
                    className="service-icon img-fluid"
                    src={require("../../../static/images/facebook-ad-icon.png")}
                  />
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0 pl-3">
                    <h3 className="my-h3-head">Facebook Advertisement</h3>
                    <p className="service-desc">
                      Running facebook ads is what we specialize in !! Being
                      able to write an effective campaign is crucial for driving
                      thousands of potential customers to websites, facebook
                      pages, and even the location itself.
                    </p>
                    <Link className="service-link" to="/">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6 p-0">
            <div className="card h-100 p-4 service">
              <div className="row no-gutters">
                <div className="col-md-2">
                  <img
                    className="service-icon img-fluid"
                    src={require("../../../static/images/web-optimization-icon.png")}
                  />
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0 pl-3">
                    <h3 className="my-h3-head">Website Optimization</h3>
                    <p className="service-desc">
                      Is your website running slow. We have the know-how to run
                      your website to the absolute best and knowing what to
                      eliminate to give your website optimum performance.
                    </p>
                    <Link className="service-link" to="/">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 p-0 my-mt-sm-3">
            <div className="card h-100 p-4 service">
              <div className="row no-gutters">
                <div className="col-md-2">
                  <img
                    className="service-icon img-fluid"
                    src={require("../../../static/images/social-media-management-icon.png")}
                  />
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0 pl-3">
                    <h3 className="my-h3-head">Social Media Management</h3>
                    <p className="service-desc">
                      We will also maintain, connect, manage and create your
                      social media accounts, while developing the most effective
                      market stratagies toward your customers.
                    </p>
                    <Link className="service-link" to="/">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-6 p-0">
            <div className="card h-100 p-4 service">
              <div className="row no-gutters">
                <div className="col-md-2">
                  <img
                    className="service-icon img-fluid"
                    src={require("../../../static/images/facebook-page-icon.png")}
                  />
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0 pl-3">
                    <h3 className="my-h3-head">Facebook Business Pages</h3>
                    <p className="service-desc">
                      Facebook business pages are an essential part of getting
                      customers to know who you are. With the amount of people
                      scolling through the news feed, thousands of people can be
                      directed to your page.
                    </p>
                    <Link className="service-link" to="/">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 p-0 my-mt-sm-3">
            <div className="card h-100 p-4 service">
              <div className="row no-gutters">
                <div className="col-md-2">
                  <img
                    className="service-icon img-fluid"
                    src={require("../../../static/images/other-services-icon.png")}
                  />
                </div>
                <div className="col-md-10">
                  <div className="card-body p-0 pl-3">
                    <h3 className="my-h3-head">Other</h3>
                    <p className="service-desc">
                      Unsure on how our services work? Or maybe you tried every
                      social media tactic and still not getting customers? Let
                      us give you a free audit on your social media pages and
                      let you know what your doing wrong.
                    </p>
                    <Link className="service-link" to="/">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ServiceSection;
